var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteppedLineType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6667 1.66667C14.6667 2.58714 13.9205 3.33333 13 3.33333C12.3013 3.33333 11.7029 2.90334 11.4552 2.29353L8.43747 2.29637L8.44236 7.50468L8.44236 7.50469C8.44264 7.80672 8.22864 8.05891 7.94389 8.11746C7.90321 8.12582 7.86109 8.13023 7.81795 8.13027L3.70846 8.13413C3.45896 8.74009 2.86263 9.16667 2.16667 9.16667C1.24619 9.16667 0.5 8.42047 0.5 7.5C0.5 6.57953 1.24619 5.83333 2.16667 5.83333C2.8696 5.83333 3.47089 6.2685 3.71585 6.88412L7.19177 6.88086L7.18691 1.70205C7.18645 1.69227 7.18621 1.68243 7.1862 1.67254C7.18588 1.33268 7.45688 1.05593 7.7947 1.04717L7.81129 1.04694L7.81602 1.04695L11.4537 1.04354C11.7005 0.431748 12.2998 0 13 0C13.9205 0 14.6667 0.746192 14.6667 1.66667Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteppedLineType);
export default __webpack_public_path__ + "static/media/stepped_line_type.b38971dae15db867b3af2d803c987cd7.svg";
export { ForwardRef as ReactComponent };